import { DashboardPageContainer } from "../components/dashboardPageContainer.styled";
import DeployConfig from "../components/deployment/deployConfig";

const DeploymentsPage = () => {
    return (
        <DashboardPageContainer>
            <DeployConfig />
        </DashboardPageContainer>
    );
};

export default DeploymentsPage;
